import React, { useState, useEffect, useCallback } from 'react';
import { Tab, Nav } from 'react-bootstrap';
import { Ot } from './Ot';
import SeguimientoEquipos from '../components/Ot/SeguimientoEquipos';
import { postSeguimientoCount } from '../api/common';

// Wrapper que combina la vista actual de /otlista/total (listado de OT)
// con los tabs de seguimiento individual por estado de EquipmentInOt.
// Tabs horizontales arriba estilo pestañas de navegador.
// Cada tab de seguimiento muestra un badge pequeño con la cantidad total
// de equipos en ese estado (igual al badge de notas de Ot.js).
const TABS = [
  { key: 'ordenes',    label: 'Órdenes de Trabajo', icon: 'bi-list-task',         estado: null },
  { key: 'procesado',  label: 'Procesados',          icon: 'bi-cpu',               estado: 'Procesado' },
  { key: 'finalizado', label: 'Finalizados',         icon: 'bi-check2-circle',     estado: 'Finalizado' },
  { key: 'aprobado',   label: 'Aprobados',           icon: 'bi-award',             estado: 'Aprobado' },
];

const OtTabsSeguimiento = () => {
  const [activeTab, setActiveTab] = useState('ordenes');
  const [counts, setCounts] = useState({ Procesado: 0, Finalizado: 0, Aprobado: 0 });
  // Filtro externo que llega desde el click en una celda OT de los tabs de
  // seguimiento. El `_ts` fuerza al componente Ot a reaccionar aunque el
  // usuario vuelva a clickear la misma OT.
  const [filtroExternoOt, setFiltroExternoOt] = useState(null);

  const navegarAOtPorNumero = useCallback((numeroOrden) => {
    if (!numeroOrden) return;
    setFiltroExternoOt({ numeroOrden: String(numeroOrden), _ts: Date.now() });
    setActiveTab('ordenes');
  }, []);

  const refrescarCounts = useCallback(async () => {
    try {
      const res = await postSeguimientoCount(['Procesado', 'Finalizado', 'Aprobado']);
      const data = res?.data?.data || {};
      setCounts({
        Procesado:  data.Procesado  || 0,
        Finalizado: data.Finalizado || 0,
        Aprobado:   data.Aprobado   || 0,
      });
    } catch (err) {
      // El badge es secundario; no molestar al usuario con Swal.
      // 403 es esperado para usuarios sin ACCIONES_SEGUIMIENTO_EQUIPO.
      console.error('No se pudieron cargar los contadores de seguimiento', err?.response?.status || err);
    }
  }, []);

  useEffect(() => { refrescarCounts(); }, [refrescarCounts]);

  return (
    <div className="container-fluid py-3">
      <Tab.Container activeKey={activeTab} onSelect={(k) => k && setActiveTab(k)}>
        {/* Pestañas horizontales arriba — Nav variant="tabs" las dibuja como
            las clásicas pestañas de navegador unidas entre sí. */}
        <Nav variant="tabs" className="mb-0 border-bottom-0">
          {TABS.map(t => {
            const total = t.estado ? counts[t.estado] : 0;
            return (
              <Nav.Item key={t.key}>
                <Nav.Link
                  eventKey={t.key}
                  style={{
                    fontWeight: activeTab === t.key ? 600 : 500,
                    color: activeTab === t.key ? '#0d6efd' : '#495057',
                    padding: '8px 16px',
                    fontSize: '0.9rem',
                  }}
                >
                  <span style={{ position: 'relative', display: 'inline-block', lineHeight: 1.2 }}>
                    <i className={`bi ${t.icon} me-2`} />
                    {t.label}
                    {total > 0 && (
                      <span
                        title={`${total} equipo(s) ${t.label.toLowerCase()}`}
                        style={{
                          position: 'absolute',
                          top: -6,
                          right: -14,
                          background: '#dc3545',
                          color: '#fff',
                          borderRadius: '50%',
                          minWidth: 14,
                          height: 14,
                          padding: '0 3px',
                          fontSize: '0.6rem',
                          fontWeight: 700,
                          lineHeight: '14px',
                          textAlign: 'center',
                          boxShadow: '0 0 0 1px #fff',
                        }}
                      >
                        {total > 99 ? '99+' : total}
                      </span>
                    )}
                  </span>
                </Nav.Link>
              </Nav.Item>
            );
          })}
        </Nav>

        {/* Contenido del tab debajo de las pestañas */}
        <div
          className="border rounded-bottom bg-white p-3"
          style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
        >
          <Tab.Content>
            <Tab.Pane eventKey="ordenes" mountOnEnter unmountOnExit={false}>
              {/* Vista original de /otlista/total — se preserva intacta
                  renderizando el componente Ot dentro de este tab. El
                  `filtroExterno` se setea cuando el usuario hace click en
                  una celda OT desde un tab de seguimiento. */}
              <Ot filtroExterno={filtroExternoOt} />
            </Tab.Pane>
            <Tab.Pane eventKey="procesado" mountOnEnter unmountOnExit={false}>
              <SeguimientoEquipos
                estado="Procesado"
                activo={activeTab === 'procesado'}
                onCountersDirty={refrescarCounts}
                onNavegarAOt={navegarAOtPorNumero}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="finalizado" mountOnEnter unmountOnExit={false}>
              <SeguimientoEquipos
                estado="Finalizado"
                activo={activeTab === 'finalizado'}
                onCountersDirty={refrescarCounts}
                onNavegarAOt={navegarAOtPorNumero}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="aprobado" mountOnEnter unmountOnExit={false}>
              <SeguimientoEquipos
                estado="Aprobado"
                activo={activeTab === 'aprobado'}
                onCountersDirty={refrescarCounts}
                onNavegarAOt={navegarAOtPorNumero}
              />
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </div>
  );
};

export default OtTabsSeguimiento;
